import { DataTableProvider } from 'components/DataTable'
import { IColumnVisibility } from 'components/DataTable/types'

import { ChainsSummary } from 'models/summaries'
import { FilterIdentifier } from 'models/saved_view'

import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { ChainsTableComponent } from './ChainsTableComponent'
import {
  chainsReportsTableVariant,
  chainsTableVariant,
} from './chainsTableVariants'

export interface IChainTable {
  setChainsSummary?: (summary: ChainsSummary) => void
  baseFilters?: Record<string, any>
  tableKey: string
  filterIdentifierModifier?: FilterIdentifier
  hideCreateCompanyButton?: boolean
  useReports?: boolean
}

export function ChainsTable(
  props: IChainTable & {
    defaultColumnVisibility?: IColumnVisibility<any>
  }
) {
  const { tableKey, defaultColumnVisibility, useReports, ...rest } = props
  const { isLoading } = useFeatureFlagService()

  // Callers derive `useReports` from flags (campaign denormalized stats), so
  // keep waiting for the flag load — mounting early would flash the wrong
  // variant's columns before flipping.
  if (isLoading) {
    return null
  }

  // The CRM-reports variant is the default (the old `enabled_report_chains`
  // flag reached 100% and was removed). Campaign tabs still force the V1
  // restaurants-bars variant via `useReports={false}` when denormalized
  // campaign stats are on.
  const variant =
    (useReports ?? true) ? chainsReportsTableVariant : chainsTableVariant

  return (
    <ColumnsStoreProvider
      tableKey={tableKey}
      defaultColumnVisibility={defaultColumnVisibility}
      savedPresetsIdentifier={'CHAINS_TABLE'}
      preferredGroupOrder={[
        'Target Attributes',
        'Campaigns and Deals',
        'Predicted Values',
        'Reputation Data',
        'Location Data',
      ]}
    >
      <DataTableProvider tableKey={tableKey}>
        <ChainsTableComponent tableKey={tableKey} variant={variant} {...rest} />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}
